export class Dropdown {
  private label: string;
  private items: string[];

  constructor(label, items) {
    this.label = label;
    this.items = items;
  }
}
